// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1219":"fd94b0f8","8345":"1fed8ae5"}[chunkId] + ".chunk.css";
};